const CardLoader = () => {
    return (
        <div className="grid grid-cols-1 grid-rows-[168px_minmax(168px,_1fr)] h-full">
            <div className="animate-pulse">
                <div className=" bg-slate-300 h-full w-full"></div>
                <div className="flex-1 space-y-6 py-4">
                    <div className="h-2 bg-slate-300 rounded"></div>
                    <div className="h-4 bg-slate-300 rounded"></div>
                    <div className="space-y-3">
                        <div className="h-2 bg-slate-300 rounded"></div>
                        <div className="h-2 bg-slate-300 rounded"></div>
                        <div className="grid grid-cols-3 gap-4 pt-[20px]">
                            <div className="h-2 bg-slate-300 rounded col-span-2"></div>
                            <div className="h-2 bg-slate-300 rounded col-span-1"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export { CardLoader };
